import React, {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { fetchGroups } from '../../store/actions/broadcastAction';
import { Grid, Typography } from '@material-ui/core';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { makeStyles } from '@material-ui/core/styles';
import ReviewUploadContact from '../reviewUploadContact';
import { Input } from '@mui/material';
import NativeSelect from '@mui/material/NativeSelect';

const useStyles = makeStyles(({
  // root: {
  //   '&:hover': {
  //     backgroundColor: 'transparent',
  //   },
  // },
  // icon: {
  //   backgroundColor: '#1D4659',
  //   // ... #somecss
  // },
  // checkedIcon: {
  //   backgroundColor: '#1D4659',
  //   // ... #somecss
  // }
}))


const AddGrup2 = ({contact, group}) => {
  const classes = useStyles();
  const dispatch = useDispatch()

  const [groupOption, setGroupOption] = useState('');
  const [inputGrup, setInputGroup] = useState({
    option: '',
    groupId: '',
    groupName: '',
    contactLists: contact
  });

  useEffect(() => {
    dispatch(fetchGroups())
  }, [dispatch])

  const groups = useSelector(state => state.broadcastReducer.groups)

  const handleRadioChange = (event) => {
    setGroupOption(event.target.value);
    setInputGroup({...inputGrup, option: event.target.value})
  };

  const handleGroupName = (event) => {
    setInputGroup({...inputGrup, groupName: event.target.value});
  };

  const handleExistGroupChange = (event) => {
    setInputGroup({
      ...inputGrup,
      groupId: event.target.value
    })
  };

  useEffect(() => {
    group({
      option: inputGrup.option,
      groupId: inputGrup.groupId,
      groupName: inputGrup.groupName,
    })
  }, [inputGrup.groupName, inputGrup.groupId])

  const customRadio =
    <Radio
      className={classes.root}
      disableRipple
      color="default"
      size="small"
      // checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      // icon={<span className={classes.icon} />}
      // {...props}
    />;

    return (
      <Grid container spacing={3} style={{justifyContent: "center"}}>
        <Grid item xs={12} md={12}>
          <Typography className="font-size-14 mb-5 bold">
            Review Kontak Anda
          </Typography>
          <Typography className="font-size-12 bold">
            Total Kontak: 3
          </Typography>
          <Typography className="font-size-10 mb-5">
            Preview kontak hanya menampilkan maksimal 5 kontak
          </Typography>
        </Grid>

        <Grid item xs={12} md={12}>
          <ReviewUploadContact contactArray={contact}/>
        </Grid>

        <Grid item xs={12} md={12}>
          <Typography className="font-size-14 bold">
            Kemanakah Kontak Tersebut Anda Simpan?
          </Typography>
          <FormControl component="fieldset">
                <RadioGroup row name="position" value={groupOption} onChange={handleRadioChange}>
                  <FormControlLabel
                    value="newGroup"
                    control={customRadio}
                    label={<span style={{ fontSize: '0.8rem', marginRight:'10px' }}>Grup kontak baru</span>}
                  />
                  <FormControlLabel
                    value="existingGroup"
                    control={customRadio}
                    label={<span style={{ fontSize: '0.8rem' }}>Grup kontak yang sudah ada</span>}
                  />
                </RadioGroup>
          </FormControl>
          {
            groupOption &&
            <div>
              <Typography className="font-size-14">
                Nama Grup Kontak
              </Typography>
              {
                ( groupOption === 'existingGroup' && groups ) ? 
                <FormControl>
                  <NativeSelect defaultValue={''} onChange={handleExistGroupChange}>
                    {
                      groups?.length > 0 &&
                      <>
                        <option disabled value={''}></option>
                        {
                          groups.map(group => {
                            return (
                                <option key={group._id} label={group.groupName}>{group._id}</option>
                            )
                          })
                        }
                      </>
                    }
                  </NativeSelect>
                </FormControl>
                :
                <Input 
                  className="font-size-12"
                  placeholder='Masukkan Nama Grup'
                  onChange={handleGroupName}
                />              
              }
            </div>
          }
        </Grid>
    </Grid>
  );
}

export default AddGrup2
